import { render, staticRenderFns } from "./unreadNotification.vue?vue&type=template&id=a6e80e0e"
import script from "./unreadNotification.vue?vue&type=script&lang=js"
export * from "./unreadNotification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/francescobarbieri/Dev/brain/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a6e80e0e')) {
      api.createRecord('a6e80e0e', component.options)
    } else {
      api.reload('a6e80e0e', component.options)
    }
    module.hot.accept("./unreadNotification.vue?vue&type=template&id=a6e80e0e", function () {
      api.rerender('a6e80e0e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/admin-panel/components/topbar/unreadNotification.vue"
export default component.exports